module.exports = __webpack_public_path__ + "img/pro-ERP.7e4f7240.jpg";